import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/core/components/ui/dialog";
import { Button } from "@/core/components/ui/button";
import { FileText } from "lucide-react";
import { ExportInsightsFiltersSummary } from "./export-insights-filters-summary";
import { ExportInsightsReportIncludes } from "./export-insights-report-includes";
import { ExportInsightsConfirmDialogProps } from "../types";
import { useTranslation } from "react-i18next";

export function ExportInsightsConfirmDialog({
  open,
  onOpenChange,
  onConfirm,
  filters,
}: ExportInsightsConfirmDialogProps) {
  const [translate] = useTranslation(["insights"]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-w-lg bg-secondary"
        aria-describedby="Exportar Relatório com Insights"
      >
        <DialogHeader className="space-y-3">
          <DialogTitle className="text-xl">
            {translate("export-insights-confirm-dialog-title")}
          </DialogTitle>
          <div className="flex items-center gap-3">
            <div className="p-2 bg-secondary-200 rounded-lg">
              <FileText className="h-5 w-5 text-primary" />
            </div>
            <div>
              <DialogDescription>
                {translate("export-insights-confirm-dialog-description")}
              </DialogDescription>
            </div>
          </div>
        </DialogHeader>

        <div className="space-y-6 py-4">
          <ExportInsightsFiltersSummary filters={filters} />
          <ExportInsightsReportIncludes />
        </div>

        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            {translate("export-insights-confirm-dialog-cancel")}
          </Button>
          <Button onClick={onConfirm} variant="default">
            {translate("export-insights-confirm-dialog-confirm")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
